import React from 'react';
import ReactDOM from 'react-dom';
import 'Styles/index';
import 'Services/yup';
import './i18n';
import App from 'Pages/App/App';
import { launchGainSightTag, launchTwak } from 'Services/Analitycs';

import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/fr';

const LEGACY_HOST_TO_CANONICAL: Record<string, string> = {
	'dev.venzagrc.com': 'dev.system.venza.io',
	'stg.venzagrc.com': 'stg.system.venza.io',
	'venzagrc.com': 'system.venza.io',
};

function redirectLegacyHostIfNeeded(): boolean {
	const target = LEGACY_HOST_TO_CANONICAL[window.location.hostname.toLowerCase()];
	if (!target) {
		return false;
	}
	window.location.replace(
		`https://${target}${window.location.pathname}${window.location.search}${window.location.hash}`
	);
	return true;
}

if (redirectLegacyHostIfNeeded()) {
	// Stop booting the SPA on legacy venzagrc.com hosts (CloudFront 301 may be skipped on cached /).
} else {
	// @NOTE: Gainsight PX Tag -> service for manage user actions
	launchGainSightTag();
	launchTwak();

	localStorage.setItem("greeting","0");
	localStorage.setItem("initalpull","0");
	localStorage.setItem("propertiescheck","0");

	ReactDOM.render(<App />, document.getElementById('root'));

	document.title = 'Venza';
}